var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.42424 3.36363C2.42424 3.02891 2.69559 2.75757 3.0303 2.75757H9.09091C9.42563 2.75757 9.69697 3.02891 9.69697 3.36363C9.69697 3.69835 9.42563 3.96969 9.09091 3.96969H3.0303C2.69558 3.96969 2.42424 3.69835 2.42424 3.36363Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.42424 5.78787C2.42424 5.45316 2.69559 5.18181 3.0303 5.18181H9.09091C9.42563 5.18181 9.69697 5.45316 9.69697 5.78787C9.69697 6.12259 9.42563 6.39393 9.09091 6.39393H3.0303C2.69558 6.39393 2.42424 6.12259 2.42424 5.78787Z",
    fill: "#666666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.0303 7.60606C2.69559 7.60606 2.42424 7.8774 2.42424 8.21212C2.42424 8.54683 2.69558 8.81818 3.0303 8.81818H9.09091C9.42563 8.81818 9.69697 8.54683 9.69697 8.21212C9.69697 7.8774 9.42563 7.60606 9.09091 7.60606H3.0303Z",
    fill: "#666666"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.42424 10.6364C2.42424 10.3016 2.69559 10.0303 3.0303 10.0303H5.45455C5.78926 10.0303 6.06061 10.3016 6.06061 10.6364C6.06061 10.9711 5.78926 11.2424 5.45455 11.2424H3.0303C2.69559 11.2424 2.42424 10.9711 2.42424 10.6364Z",
    fill: "#666666"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.15151C0 1.14736 0.814028 0.333328 1.81818 0.333328H10.303C11.3072 0.333328 12.1212 1.14736 12.1212 2.15151V11.8485C12.1212 12.8526 11.3072 13.6667 10.303 13.6667H1.81818C0.814028 13.6667 0 12.8526 0 11.8485V2.15151ZM1.81818 1.54545H10.303C10.6377 1.54545 10.9091 1.81679 10.9091 2.15151V11.8485C10.9091 12.1832 10.6377 12.4545 10.303 12.4545H1.81818C1.48346 12.4545 1.21212 12.1832 1.21212 11.8485V2.15151C1.21212 1.81679 1.48346 1.54545 1.81818 1.54545Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.d7d117dc6bcdb347fc6014c0516f4c42.svg";
export { ForwardRef as ReactComponent };